import { withAppCrashIfException } from 'epic';
import { fetchMonthlyExpiryCalendarsDatesEpic } from 'epic/common-form/fetchMonthlyExpiryCalendarsDatesEpic';
import { combineEpics } from 'redux-observable';

import { cancelQuoteEpic } from './cancelQuoteEpic';
import { fetchStatifiedLastQuoteEpic } from './fetch-last-quote';
import { fetchDocumentationEpic } from './fetchDocumentation.epic';
import { fetchDynamicProductsEpic, fetchProductsReferentialOnUserInfoReceivedEpic } from './fetchProductsReferential';
import { fetchSettlementCalendarsBlackoutDatesEpic } from './fetchSettlementCalendarsBlackoutDatesEpic';
import { fetchValuationCalendarsBlackoutDatesEpic } from './fetchValuationCalendarsBlackoutDatesEpic';
import { statifiedPostReloadTradeAuthorizationEpic, statifiedTradeAuthorizationEpic } from './trade-authorization';

export const commonFormEpic = () =>
  withAppCrashIfException(
    'commonForm',
    combineEpics(
      fetchValuationCalendarsBlackoutDatesEpic(),
      fetchSettlementCalendarsBlackoutDatesEpic(),
      fetchMonthlyExpiryCalendarsDatesEpic(),
      fetchProductsReferentialOnUserInfoReceivedEpic(),
      fetchDynamicProductsEpic(),
      fetchDocumentationEpic(),
      cancelQuoteEpic(),
      fetchStatifiedLastQuoteEpic(),
      statifiedTradeAuthorizationEpic(),
      statifiedPostReloadTradeAuthorizationEpic(),
    ),
  );
